import React from 'react';
import './contact.css'


function Contactheader() {
  return (
    <section className="jumbotron text-center contactHeader">
        <h1 className="display-3">Contact Me</h1>
        <p className="lead">Open to career opportunities, freelance work, and collaborative projects.</p>
        <p>Please connect with me by submitting the form below or via email at tara.brichetto@gmail.com</p>
    </section>
  );
}

export default Contactheader;